module.exports = __webpack_public_path__ + "static/media/theme_junglen.08c00ece.jpg";